function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { getDefaultFormState, retrieveSchema, shouldRender, toIdSchema, setState, getDefaultRegistry, deepEquals } from "./utils";
import validateFormData, { toErrorList } from "./utils/validate";

class SchemaBase extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onChange", (formData, newErrorSchema) => {
      console.log('schemaForm:onChange');
      const mustValidate = !this.props.noValidate && this.props.liveValidate;
      let state = {
        formData
      };

      if (mustValidate) {
        console.log('must validate');

        const _this$validate = this.validate(formData),
              errors = _this$validate.errors,
              errorSchema = _this$validate.errorSchema;

        state = _extends({}, state, {
          errors,
          errorSchema
        });
      } else if (!this.props.noValidate && newErrorSchema) {
        state = _extends({}, state, {
          errorSchema: newErrorSchema,
          errors: toErrorList(newErrorSchema)
        });
      }

      setState(this, state, () => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      });
    });

    _defineProperty(this, "onBlur", (...args) => {
      if (this.props.onBlur) {
        this.props.onBlur(...args);
      }
    });

    _defineProperty(this, "onFocus", (...args) => {
      if (this.props.onFocus) {
        this.props.onFocus(...args);
      }
    });

    _defineProperty(this, "onSubmit", event => {
      console.log('schemaForm:onSubmit'); //        event.preventDefault();
      //        event.persist();

      const _this$validate2 = this.validate(this.state.formData),
            errors = _this$validate2.errors,
            errorSchema = _this$validate2.errorSchema;

      this.setState({
        errors: [],
        errorSchema: {}
      }, () => {
        if (this.props.onSubmit) {
          this.props.onSubmit(_extends({}, this.state, {
            errors: errors,
            errorSchema: errorSchema,
            status: "submitted"
          }));
        }
      });
    });

    _defineProperty(this, "getRegistry", () => {
      // For BC, accept passed SchemaField and TitleField props and pass them to
      // the "fields" registry one.
      const _getDefaultRegistry = getDefaultRegistry(),
            fields = _getDefaultRegistry.fields,
            fieldtypes = _getDefaultRegistry.fieldtypes,
            widgets = _getDefaultRegistry.widgets,
            layouts = _getDefaultRegistry.layouts;

      return {
        fields: _extends({}, fields, {}, this.props.fields),
        fieldtypes: _extends({}, fieldtypes, {}, this.props.fieldtypes),
        widgets: _extends({}, widgets, {}, this.props.widgets),
        layouts: _extends({}, layouts, {}, this.props.layouts),
        ArrayFieldTemplate: this.props.ArrayFieldTemplate,
        ObjectFieldTemplate: this.props.ObjectFieldTemplate,
        FieldTemplate: this.props.FieldTemplate,
        definitions: this.props.schema.definitions || {},
        formContext: this.props.formContext || {}
      };
    });

    _defineProperty(this, "submit", () => {
      if (this.formElement) {
        this.formElement.dispatchEvent(new Event("submit", {
          cancelable: true
        }));
      }
    });

    this.state = this.getStateFromProps(props);

    if (this.props.onChange && !deepEquals(this.state.formData, this.props.formData)) {
      this.props.onChange(this.state);
    }

    this.formElement = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextState = this.getStateFromProps(nextProps);

    if (!deepEquals(nextState.formData, nextProps.formData) && !deepEquals(nextState.formData, this.state.formData) && this.props.onChange) {
      this.props.onChange(nextState);
    }

    this.setState(nextState);
  }

  getStateFromProps(props) {
    const state = this.state || {};
    let schema = "schema" in props ? props.schema : this.props.schema;
    const uiSchema = "uiSchema" in props ? props.uiSchema : this.props.uiSchema;
    const edit = typeof props.formData !== "undefined";
    const liveValidate = props.liveValidate || this.props.liveValidate;
    const mustValidate = edit && !props.noValidate && liveValidate;
    const definitions = schema.definitions;
    const formData = getDefaultFormState(schema, props.formData, definitions);
    const retrievedSchema = retrieveSchema(schema, definitions, formData);
    const additionalMetaSchemas = props.additionalMetaSchemas;

    const _ref = mustValidate ? this.validate(formData, schema, additionalMetaSchemas) : {
      errors: state.errors || [],
      errorSchema: state.errorSchema || {}
    },
          errors = _ref.errors,
          errorSchema = _ref.errorSchema;

    const idSchema = toIdSchema(retrievedSchema, uiSchema["ui:rootFieldId"], definitions, formData, props.idPrefix);
    return {
      schema,
      uiSchema,
      idSchema,
      formData,
      edit,
      errors,
      errorSchema,
      additionalMetaSchemas
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shouldRender(this, nextProps, nextState);
  }

  validate(formData, schema = this.props.schema, additionalMetaSchemas = this.props.additionalMetaSchemas) {
    const _this$props = this.props,
          validate = _this$props.validate,
          transformErrors = _this$props.transformErrors;

    const _this$getRegistry = this.getRegistry(),
          definitions = _this$getRegistry.definitions;

    const resolvedSchema = retrieveSchema(schema, definitions, formData);
    return validateFormData(formData, resolvedSchema, validate, transformErrors, additionalMetaSchemas);
  }

  render() {
    const _this$props2 = this.props,
          idPrefix = _this$props2.idPrefix,
          safeRenderCompletion = _this$props2.safeRenderCompletion,
          disabled = _this$props2.disabled;
    const _this$state = this.state,
          schema = _this$state.schema,
          uiSchema = _this$state.uiSchema,
          formData = _this$state.formData,
          errorSchema = _this$state.errorSchema,
          idSchema = _this$state.idSchema;
    const registry = this.getRegistry();
    const SchemaField = registry.fields.SchemaField;
    return React.createElement(SchemaField, {
      schema: schema,
      uiSchema: uiSchema,
      errorSchema: errorSchema,
      idSchema: idSchema,
      idPrefix: idPrefix,
      formData: formData,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      registry: registry,
      safeRenderCompletion: safeRenderCompletion,
      disabled: disabled
    });
  }

}

_defineProperty(SchemaBase, "defaultProps", {
  className: "schema",
  schema: {},
  uiSchema: {},
  formData: {},
  formContext: {
    language: "en",
    expandId: undefined,
    settings: false
  }
});

SchemaBase.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formData: PropTypes.any,
  widgets: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
  fields: PropTypes.objectOf(PropTypes.func),
  layouts: PropTypes.objectOf(PropTypes.func),
  ArrayFieldTemplate: PropTypes.func,
  ObjectFieldTemplate: PropTypes.func,
  FieldTemplate: PropTypes.func,
  ErrorList: PropTypes.func,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  showErrorList: PropTypes.bool,
  onSubmit: PropTypes.func,
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  method: PropTypes.string,
  target: PropTypes.string,
  action: PropTypes.string,
  autocomplete: PropTypes.string,
  enctype: PropTypes.string,
  acceptcharset: PropTypes.string,
  noValidate: PropTypes.bool,
  noHtml5Validate: PropTypes.bool,
  liveValidate: PropTypes.bool,
  validate: PropTypes.func,
  transformErrors: PropTypes.func,
  safeRenderCompletion: PropTypes.bool,
  formContext: PropTypes.object,
  additionalMetaSchemas: PropTypes.arrayOf(PropTypes.object)
} : {};
export default SchemaBase;